import React, { useState } from "react";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import ToggleButtonComponent from "./ToggleButtonComponent";
import { TextField } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import Button from "@material-ui/core/Button";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import { makeStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import PasteIcon from "@material-ui/icons/FileCopy";
import CancelIcon from "@material-ui/icons/Cancel";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import { withStyles } from "@material-ui/styles";
import FolderIcon from "@material-ui/icons/Folder";
import HomeIcon from "@material-ui/icons/Home";
import {
  checkCutStatus,
  searchContent,
  selCutStatus,
  selNavs,
  setCutClose,
} from "app/routes/dashboard/routes/library/slice/librarySlice";
import {
  changeCurFolderByContent,
  moveContent,
} from "app/routes/dashboard/routes/library/slice/libraryThunks";
import { useDispatch, useSelector } from "react-redux";
import { useDebounce } from "util/index";
import { FAILEDCUT, INITCUT } from "../../slice/constants";

const BootstrapButton = withStyles({
  root: {
    boxShadow: "none",
    textTransform: "none",
    fontSize: 16,
    padding: "6px 12px",
    lineHeight: 1.5,
    backgroundColor: "#0063cc",
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:hover": {
      boxShadow: "none",
    },
    "&:active": {
      boxShadow: "none",
    },
    // '&:focus': {
    //   boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
    // },
  },
})(Button);

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  item: {
    fontSize: 18,
    cursor: "pointer",
  },
  rootIcons: {
    display: "flex",
    position: "relative",
  },
  homeIcon: {
    position: "absolute",
    left: 11,
    top: 15,
    fontSize: 22,
  },
  folderIcon: {
    fontSize: 46,
    color: "lightgray",
    position: "relative",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

// const getDisplayString = (sub) => {
//   const arr = sub.split("-");
//   if (arr.length > 1) {
//     return (
//       arr[0].charAt(0).toUpperCase() +
//       arr[0].slice(1) +
//       " " +
//       arr[1].charAt(0).toUpperCase() +
//       arr[1].slice(1)
//     );
//   } else {
//     return sub.charAt(0).toUpperCase() + sub.slice(1);
//   }
// };
// const getUrlString = (path, sub, index) => {
//   if (index === 0) {
//     return "#/";
//   } else {
//     return "#/" + path.split(sub)[0] + sub;
//   }
// };

const ContainerHeader = (props) => {
  const classes = useStyles();
  const navs = useSelector(selNavs);
  const dispatch = useDispatch();
  const l = navs.length;
  const [sorter, setSorter] = useState({
    val: "created_time",
    asc: true,
    type: "sort",
  });
  const cutStatus = useSelector(selCutStatus);
  const [search, setSearch] = useState("");

  const { openModal } = props;

  const handleNav = (content, idx) => () => {
    dispatch(checkCutStatus(content));
    dispatch(changeCurFolderByContent(content, idx));
  };

  const handleChange = (input) => (e) => {
    setSearch("");
    const { value } = e.target;
    let newSorter = { ...sorter, [input]: value };
    if (input === "val") newSorter = { ...newSorter, asc: true };
    setSorter(newSorter);
    dispatch(searchContent(newSorter));
    // if (input === "val") setSorter((prev) => ({ ...prev, asc: true }));
  };

  function onSearch(payload) {
    dispatch(searchContent(payload));
  }

  const debouncedSearch = useDebounce(onSearch, 500);

  // const debouncedSearch = debounce_(false, 500, onSearch)();

  function handleSearch(e) {
    const { value } = e.target;
    setSearch(value);
    if (!value) dispatch(searchContent({ val: null, type: "all" }));
    if (value.length < 3) return "";
    return debouncedSearch({ ...sorter, type: "search", search: value });
  }

  function cancelCut() {
    return dispatch(setCutClose());
  }

  function acceptCut() {
    dispatch(moveContent());
  }

  const handleModal = (type) => () => openModal(type);
  // const path = match.path.substr(1);
  // const subPath = path.split("/");
  return (
    <div className="page-heading  d-sm-flex flex-row justify-content-sm-between">
      <div className=" d-sm-flex flex-column justify-content-sm-between ">
        <div className="d-flex">
          <h2 className="title mb-sm-0">File Manager</h2>
          {cutStatus !== INITCUT && (
            <div className="ml-3 mb-2">
              <Button
                onClick={cancelCut}
                className="mr-1"
                variant="contained"
                startIcon={<CancelIcon />}
              >
                Cancel
              </Button>
              <Button
                onClick={acceptCut}
                className="mr-1"
                variant="contained"
                color="primary"
                startIcon={<PasteIcon />}
                disabled={cutStatus === FAILEDCUT}
              >
                Paste
              </Button>
            </div>
          )}
        </div>

        <Breadcrumb className="mb-0 d-flex align-items-center" tag="nav">
          {navs.map((nav, idx) => {
            const active = idx + 1 < l;
            // debugger;
            return nav.title !== "root" ? (
              <BreadcrumbItem
                tag="a"
                active={active}
                key={`${nav.id}_bread`}
                onClick={active ? handleNav(nav, idx) : null}
                className={`${classes.item} d-flex align-items-center`}
              >
                {nav.title}
              </BreadcrumbItem>
            ) : (
              <BreadcrumbItem
                tag="a"
                active={active}
                onClick={active ? handleNav(nav, idx) : null}
                className={classes.rootIcons}
              >
                <FolderIcon className={classes.folderIcon} />
                <HomeIcon className={classes.homeIcon} />
              </BreadcrumbItem>
            );
          })}
        </Breadcrumb>
      </div>
      <div className="d-flex flex-column align-items-end">
        <div>
          <BootstrapButton
            variant="contained"
            color="default"
            disableRipple
            onClick={handleModal("folder")}
            className="mr-1"
            startIcon={<AddIcon />}
          >
            NEW FOLDER
          </BootstrapButton>
          <BootstrapButton
            disableRipple
            onClick={handleModal("file")}
            className="mr-1"
            variant="contained"
            color="primary"
            startIcon={<CloudUploadIcon />}
          >
            Upload
          </BootstrapButton>
        </div>
        <div className="d-sm-flex flex-row justify-content-sm-between">
          <FormControl className={`${classes.formControl} mr-3`}>
            <InputLabel id="demo-simple-select-label">Sort</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={sorter.val}
              onChange={handleChange("val")}
            >
              <MenuItem value={"title"}>Name</MenuItem>
              <MenuItem value={"created_time"}>Date</MenuItem>
              {/* <MenuItem value={30}>File</MenuItem>
              <MenuItem value={40}>Folder</MenuItem> */}
            </Select>
          </FormControl>
          {/* <FormControl className={`${classes.formControl} mr-3`}>
            <InputLabel id="demo-simple-select-label">Sort by Status</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={sorter.asc}
              onChange={handleChange("asc")}
            >
              <MenuItem value={true}>All</MenuItem>
              <MenuItem value={false}>Deleted</MenuItem>
              <MenuItem value={false}>Deactive</MenuItem>
            </Select>
          </FormControl>
           */}
          <FormControl className={`${classes.formControl} mr-3`}>
            <InputLabel id="demo-simple-select-label">Order</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={sorter.asc}
              onChange={handleChange("asc")}
            >
              <MenuItem value={true}>Ascending</MenuItem>
              <MenuItem value={false}>Descending</MenuItem>
            </Select>
          </FormControl>
          <FormControl
            className={`${classes.formControl} mr-3`}
            noValidate
            autoComplete="off"
          >
            <TextField label="Search" value={search} onChange={handleSearch} />
          </FormControl>

          <div className="d-flex align-self-end mr-1">
            <ToggleButtonComponent />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContainerHeader;
